import React, { useState, useEffect } from "react";
import { Stack, TextField, Button, MenuItem, Select, InputLabel, FormControl, Box, IconButton } from "@mui/material";
import { DeleteIcon } from "../Icon";
import { useGetQuote } from "../../hooks/useGetQuote";
import { IGetQuote } from "../../interfaces/IgetQuote";

export const ShipmentItems = ({ CustomerDetails, fieldsConfig, menuItems, onPackageSelect, disableGetQuote, data }) => {
  const initialPackage = menuItems[0]?.package;

  const [formData, setFormData] = useState<IGetQuote>({
    address: {
      ...CustomerDetails,
    },
    items: [
      {
        packageName: menuItems[0]?.value || "",
        reference: initialPackage?.reference || "",
        weight: initialPackage?.weight || "",
        quantity: initialPackage?.quantity || "",
        length: initialPackage?.length || "",
        width: initialPackage?.width || "",
        height: initialPackage?.height || "",
      },
    ],
  });

  //Todo: Add the data under the getQuoteData which is left empty string
  const { loadingGetQuote, refetchGetQuote, getQuoteResponse } = useGetQuote({
    getQuoteData: {
      address: { ...CustomerDetails },
      items: formData.items,
      requestShippingCarrier: data?.requestShippingCarrier,
      requestedShippingClass: data?.requestedShippingClass,
      siteName: data?.siteName,
    },
    enabled: false,
  });
  useEffect(() => {
    if (initialPackage) {
      onPackageSelect(initialPackage);
    }
  }, [initialPackage, onPackageSelect]);

  const handleChange = (e, index) => {
    const { name, value } = e.target;

    setFormData((prevFormData) => {
      const updatedItems = [...prevFormData.items]; // Create a shallow copy of the items array
      const selectedPackage = menuItems.find((item) => item.value === value)?.package;

      if (name === "dropdownValue") {
        if (selectedPackage) {
          updatedItems[index] = {
            packageName: value,
            reference: selectedPackage.reference || "",
            weight: selectedPackage.weight || "",
            quantity: selectedPackage.quantity || "",
            length: selectedPackage.length || "",
            width: selectedPackage.width || "",
            height: selectedPackage.height || "",
          };
        }
      } else {
        updatedItems[index] = {
          ...updatedItems[index],
          [name]: value,
        };
      }

      return { ...prevFormData, items: updatedItems };
    });
  };

  const handleAddMoreFields = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      items: [
        ...prevFormData.items,
        {
          packageName: menuItems[0]?.value || "",
          reference: initialPackage?.reference || "",
          weight: initialPackage?.weight || "",
          quantity: initialPackage?.quantity || "",
          length: initialPackage?.length || "",
          width: initialPackage?.width || "",
          height: initialPackage?.height || "",
        },
      ],
    }));
  };

  const handleRemoveField = (indexToRemove) => {
    setFormData((prevFormData) => {
      const updatedItems = prevFormData.items.filter((_, index) => index !== indexToRemove);
      return {
        ...prevFormData,
        items: updatedItems,
      };
    });
  };

  const handleGetQuoteSubmit = () => {
    refetchGetQuote();
  };

  return (
    <>
      <Stack spacing={2} padding={1} sx={{ border: "2px solid #007bff", borderRadius: "8px", padding: 2 }}>
        {formData.items.map((packageData, index) => (
          <Box key={index} margin={2} sx={{ position: "relative" }}>
            <Stack spacing={2} direction="row" alignItems="center">
              <FormControl sx={{ width: "20%" }}>
                <InputLabel id={`dropdown-label-${index}`}>Select Item</InputLabel>
                <Select
                  variant="standard"
                  labelId={`dropdown-label-${index}`}
                  name="dropdownValue"
                  value={packageData.packageName || ""}
                  onChange={(e) => handleChange(e, index)}
                >
                  {menuItems.map((item) => (
                    <MenuItem key={item.value} value={item.value}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <Stack spacing={4} direction="row">
                {fieldsConfig.map((field) => (
                  <TextField
                    key={field.name}
                    variant="standard"
                    label={field.label}
                    name={field.name}
                    value={packageData[field.name]}
                    onChange={(e) => handleChange(e, index)}
                    sx={{ width: "15%" }}
                  />
                ))}
                <IconButton onClick={() => handleRemoveField(index)}>
                  <DeleteIcon />
                </IconButton>
              </Stack>
            </Stack>
          </Box>
        ))}

        <Button variant="contained" color="primary" onClick={handleAddMoreFields} sx={{ mt: 5 }}>
          Add Package
        </Button>
      </Stack>
      <Button
        fullWidth
        variant="contained"
        color="primary"
        onClick={handleGetQuoteSubmit}
        sx={{ mt: 2 }}
        //disabled={disableGetQuote}
      >
        Get Quote
      </Button>
    </>
  );
};
